import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Icon } from "./index";

const Label = styled.span`
  ${props =>
    props.marginPosition ? `margin-${props.marginPosition}: 8px;` : ""};
`;

const getMarginPosition = labelPosition => {
  if (labelPosition === "right") return "left";
  else if (labelPosition === "left") return "right";
  else if (labelPosition === "top") return "bottom";
  else if (labelPosition === "bottom") return "top";
  return null;
};

const propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  labelPosition: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  costomStyles: PropTypes.string
};
const defaultProps = {
  label: "",
  labelPosition: "right",
  color: "inherit",
  hoverColor: "",
  costomStyles: ""
};
export const IconLabel = ({
  label,
  children,
  labelPosition,
  color,
  hoverColor,
  costomStyles
}) => {
  const marginPosition = getMarginPosition(labelPosition);
  const styles = "display: flex; align-items: center;" + costomStyles;
  return (
    <Icon color={color} hoverColor={hoverColor} costomStyles={styles}>
      {labelPosition === "left" || labelPosition === "top" ? null : children}
      <Label marginPosition={marginPosition}>{label}</Label>
      {labelPosition === "right" || labelPosition === "bottom"
        ? null
        : children}
    </Icon>
  );
};

IconLabel.propTypes = propTypes;
IconLabel.defaultProps = defaultProps;

export default IconLabel;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Icons/IconLabel.js